module.exports = __webpack_public_path__ + "static/media/buy_me_a_coffee.13847027.png";